var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "toggled-options map-panel" }, [
      _c("div", { staticClass: "map-panel--routing_options" }, [
        _c(
          "button",
          { on: { click: _vm.handleMapToggle } },
          [
            _c("md-icon", [_vm._v("announcement")]),
            _c(
              "md-tooltip",
              {
                staticClass: "toggle-tooltip",
                attrs: { "md-direction": "bottom" },
              },
              [_vm._v("Try the new map")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }